export default __webpack_public_path__ + "static/media/arrow-forward.e80bcbf6.svg";